import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function PageHero({ eyebrow, title, subtitle, image, testIdPrefix = "page-hero", ctaTo, ctaLabel }) {
  return (
    <section
      data-testid={`${testIdPrefix}-section`}
      className="relative isolate overflow-hidden bg-brand-forest"
    >
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-60" aria-hidden="true" />
          <div className="absolute inset-0 bg-gradient-to-br from-brand-forest/80 via-brand-forest/70 to-brand-ink/80" />
        </div>
      )}
      {!image && <div className="absolute inset-0 bg-topo opacity-25" aria-hidden="true" />}

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-24 md:py-36">
        <div className="max-w-3xl">
          {eyebrow && (
            <p className="eyebrow text-brand-gold" data-testid={`${testIdPrefix}-eyebrow`}>
              {eyebrow}
            </p>
          )}
          <h1
            className="mt-5 font-heading text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight"
            data-testid={`${testIdPrefix}-title`}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              className="mt-8 text-white/85 text-lg md:text-xl max-w-2xl leading-relaxed font-light"
              data-testid={`${testIdPrefix}-subtitle`}
            >
              {subtitle}
            </p>
          )}
          {ctaTo && (
            <Link
              to={ctaTo}
              data-testid={`${testIdPrefix}-cta`}
              className="mt-10 inline-flex items-center gap-2 px-8 py-4 bg-brand-gold text-brand-ink text-[12px] uppercase tracking-[0.24em] font-semibold rounded-sm hover:bg-white transition-all duration-300"
            >
              {ctaLabel} <ArrowRight size={16} />
            </Link>
          )}
        </div>
      </div>

      <svg
        className="absolute bottom-0 left-0 w-full text-brand-ivory"
        viewBox="0 0 1440 60"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path fill="currentColor" d="M0,30 C320,70 720,0 1080,30 C1260,45 1380,40 1440,30 L1440,60 L0,60 Z" />
      </svg>
    </section>
  );
}
